export default class Announcement {
  id: string;
  name: string;
  templateId = '';
  contentType = '';
  imageId = '';
  title = '';
  content = '';
  begin = new Date();
  end = new Date();
  boardList: Array<string> = [];

  constructor (id: string, displayName: string) {
    this.id = id
    this.name = displayName
  }
}
